export default "__VITE_ASSET__UCvkrouW__"